import React from 'react';
import withAuthorization from '../Session/withAuthorization';
import ComplainsTablePage from '../Complains/TableComplains';
import {compose} from 'recompose';
import { inject, observer } from 'mobx-react';

const AccountPage = ({ sessionStore }) =>
      <div>
        <ComplainsTablePage></ComplainsTablePage>
      </div>

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  inject('sessionStore'),
  observer
)(AccountPage);


// WEBPACK FOOTER //
// ./src/components/Account/index.js